import React, { useState } from 'react';
import './LeadCapture.css';

function LeadCapture() {
  const [email, setEmail] = useState('');
  const [pergunta, setPergunta] = useState('');
  const [resposta, setResposta] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    setLoading(true);
    setResposta('');

    // Simula um tempo de carregamento de 1 segundo para dar a sensação de envio
    setTimeout(() => {
      // Exibe a mensagem exata que você solicitou
      setResposta('Estaremos conectado em breve e você será informado!');
      setLoading(false);
      
      // Limpa os campos após o envio
      setEmail('');
      setPergunta('');
    }, 1000);
  };

  return (
    <section className="lead-capture-container" style={{ maxWidth: '100vw', overflowX: 'hidden' }}>
      {/* 
        Estilo embutido para consertar o layout no celular sem precisar editar o arquivo CSS.
        No celular, os campos ficam em coluna. No Web, ficam em linha.
      */}
      <style>
        {`
          .lead-form-responsive {
            display: flex;
            flex-direction: column; /* No celular, empilha os itens */
            gap: 15px;
            max-width: 800px;
            margin: 0 auto;
            width: 100%;
            padding: 0 15px;
            box-sizing: border-box;
          }
          
          /* Quando a tela for maior que 768px (Computador), coloca lado a lado */
          @media (min-width: 768px) {
            .lead-form-responsive {
              flex-direction: row; 
            }
          }

          .lead-form-responsive input {
            flex: 1;
            padding: 15px;
            border-radius: 6px;
            border: none;
            width: 100%;
            box-sizing: border-box;
            font-size: 16px;
          }

          .lead-form-responsive button {
            padding: 15px 24px;
            border-radius: 6px;
            border: none;
            background-color: #007BFF;
            color: white;
            font-weight: bold;
            cursor: pointer;
            white-space: nowrap;
            font-size: 16px;
          }

          .lead-form-responsive button:disabled {
            background-color: #555;
            cursor: wait;
          }
          
          .mensagem-sucesso {
            margin-top: 20px;
            color: #4CAF50; /* Cor verde para indicar sucesso */
            font-size: 18px;
            font-weight: bold;
          }
        `}
      </style>

      <h3>Experimente a Aetheries</h3>
      <p>Envie uma questão ética para nossa IA analisar.</p>
      
      <form onSubmit={handleSubmit} className="lead-form-responsive">
        <input 
          type="email" 
          placeholder="Seu e-mail corporativo" 
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          required
        />
        <input 
          type="text" 
          placeholder="Como posso te ajudar hoje?" 
          value={pergunta}
          onChange={(e) => setPergunta(e.target.value)}
          required
        />
        <button type="submit" disabled={loading}>
          {loading ? 'Enviando...' : 'Testar Agora'}
        </button>
      </form>
      
      {resposta && <div className="mensagem-sucesso">{resposta}</div>}
    </section>
  );
}

export default LeadCapture;